import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'checkout_flight_summary';
export const route = 'checkout_flight_summary/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/FlightSummaryPage')));